import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAboutSite, getAboutPhoto } from "../../store/about/aboutAction";
import { baseUrl } from "../../utils/APi";
import Loader from "../../component/Loader";
import { Link } from "react-router-dom";
import img1 from "../../assets/main/8.jpg";
import img2 from "../../assets/main/5.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
const About = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { aboutSite, aboutPhoto, loading } = useSelector(
    (state) => state.aboutSlicer
  );

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${img1})` }}
      >
        <div class="container-fluid ">
          <div class="row ">
            <div class="breadcrumbs text-center link-style-5 text-white bg-black">
              <h2 class="section-title-page">About Us</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <Link class="section-16px-regular font-weight-500" to={"/"}>
                    Home
                  </Link>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">About me</h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="flat-about-2nd">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="about-content-left wow fadeInLeft">
                <div class="about-post">
                  <img src={img1} alt="images" />

                  <div class="mark-about-post"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="about-content-right wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div class="section-title">
                  <h4 class="section-subtitle">Know More</h4>
                  <h2 class="section-45px-montserrat margin-top-15 margin-bottom-20">
                    Our Story
                  </h2>
                </div>
                <p class="section-17px-regular margin-bottom-25">
                  Etiam efficitur, metus in cursus imperdiet, neque nisl porta
                  erat, nec volutpat felis lacus a tellus. Nunc tristique nulla
                  nisi, a viverra dui auctor vitae. Vestibulum mollis commodo
                  leo in hendrerit. Nam convallis ac lacus luctus vestibulum.
                  Donec cursus tellus id neque convallis blandit.
                </p>
                <p class="section-17px-regular font-weight-500 margin-bottom-12">
                  <i>
                    ” Etiam hendrerit lacinia lorem eu interdum. Duis malesuada,
                    enim interdum dictum commodo “
                  </i>
                </p>
                <p class="section-17px-regular">
                  Etiam efficitur, metus in cursus imperdiet, neque nisl porta
                  erat, nec volutpat felis lacus a tellus. Nunc tristique nulla
                  nisi, a viverra dui auctor vitae. Vestibulum mollis commodo
                  leo in hendrerit. Nam convallis ac
                </p>
                <div
                  class="button-about margin-top-48 wow fadeInUp"
                  data-wow-delay="600ms"
                  data-wow-duration="1500ms"
                >
                  <a
                    href="contact.html"
                    class="button-footer arrow-btn btn-st btn-style-1"
                  >
                    Hire Me Now
                  </a>
                  <a
                    href="services.html"
                    class="button-footer arrow-btn btn-st style-3"
                  >
                    View All Projects
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="flat-work parallax parallax-1">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h4 className="section-subtitle">Work Experience</h4>
                <h2 className="section-45px-montserrat margin-top-15">
                  My Experience
                </h2>
              </div>
              <div className="themesflat-spacer clearfix" />
              <Swiper
                modules={[Navigation, Pagination]}
                direction="vertical"
                spaceBetween={0}
                slidesPerView={5}
                centeredSlides={true}
                loop={true}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                pagination={{
                  clickable: true,
                  el: ".swiper-pagination",
                }}
                className="sliver-vertical"
              >
                <SwiperSlide>
                  <div className="work-box">
                    <div className="work-box-left">
                      <div className="date section-14px-regular font-weight-700 margin-bottom-12">
                        2010 - 2018
                      </div>
                      <div className="job section-20px-montserrat">
                        Apparel Software
                      </div>
                    </div>
                    <div className="work-box-center">
                      <div className="work-job">
                        <h3 className="section-20px-montserrat">
                          Senior Product
                        </h3>
                        <h3 className="section-20px-montserrat">Designer</h3>
                      </div>
                    </div>
                    <div className="work-box-right">
                      <div className="work-introduce">
                        <p>
                          Etiam efficitur, metus in cursus imperdiet, neque nisl
                          porta erat, nec volutpat felis lacus a tellus. Nunc
                          tristique nulla nisi, a viverra dui auctor vitae.
                          Vestibulum
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="work-box">
                    <div className="work-box-left">
                      <div className="date section-14px-regular font-weight-700 margin-bottom-12">
                        2010 - 2018
                      </div>
                      <div className="job section-20px-montserrat">
                        Disney World Limited
                      </div>
                    </div>
                    <div className="work-box-center">
                      <div className="work-job">
                        <h3 className="section-20px-montserrat">
                          Senior Product
                        </h3>
                        <h3 className="section-20px-montserrat">Designer</h3>
                      </div>
                    </div>
                    <div className="work-box-right">
                      <div className="work-introduce">
                        <p>
                          Etiam efficitur, metus in cursus imperdiet, neque nisl
                          porta erat, nec volutpat felis lacus a tellus. Nunc
                          tristique nulla nisi, a viverra dui auctor vitae.
                          Vestibulum
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="work-box">
                    <div className="work-box-left">
                      <div className="date section-14px-regular font-weight-700 margin-bottom-12">
                        2010 - 2018
                      </div>
                      <div className="job section-20px-montserrat">
                        The UX Lab Inc.
                      </div>
                    </div>
                    <div className="work-box-center">
                      <div className="work-job">
                        <h3 className="section-20px-montserrat">
                          Senior Product
                        </h3>
                        <h3 className="section-20px-montserrat">Designer</h3>
                      </div>
                    </div>
                    <div className="work-box-right">
                      <div className="work-introduce">
                        <p>
                          Etiam efficitur, metus in cursus imperdiet, neque nisl
                          porta erat, nec volutpat felis lacus a tellus. Nunc
                          tristique nulla nisi, a viverra dui auctor vitae.
                          Vestibulum
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default About;
